import { Calculator } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const StepCalculator = ({ formData, handleChange, loanAmount, formatCurrency }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-[#00D47E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Calculator className="w-7 h-7 text-[#00D47E]" />
        </div>
        <h2 className="font-outfit text-2xl md:text-3xl font-bold text-black mb-2">
          Quick Calculator
        </h2>
        <p className="text-gray-600">How much would you like to borrow?</p>
      </div>

      <div className="space-y-6">
        <div>
          <Label className="text-gray-700">Amount to Borrow</Label>
          <div className="mt-2 relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">$</span>
            <Input
              type="number"
              value={formData.borrow_amount}
              onChange={(e) => handleChange('borrow_amount', parseInt(e.target.value, 10) || 0)}
              className="pl-8 text-2xl font-bold h-14"
              data-testid="borrow-amount-input"
            />
          </div>
          <input
            type="range"
            min="1000"
            max="350000"
            step="1000"
            value={formData.borrow_amount}
            onChange={(e) => handleChange('borrow_amount', parseInt(e.target.value, 10))}
            className="w-full mt-3"
            data-testid="borrow-amount-slider"
          />
          <div className="flex justify-between text-xs text-gray-400 mt-1">
            <span>$1,000</span>
            <span>$350,000</span>
          </div>
        </div>

        <div>
          <Label className="text-gray-700">Your Deposit</Label>
          <div className="mt-2 relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">$</span>
            <Input
              type="number"
              value={formData.deposit_amount}
              onChange={(e) => handleChange('deposit_amount', parseInt(e.target.value, 10) || 0)}
              className="pl-8 text-xl h-12"
              data-testid="deposit-amount-input"
            />
          </div>
        </div>

        <div className="bg-[#00D47E] rounded-xl p-6 text-center">
          <p className="text-white/80 text-sm mb-1">Loan Amount</p>
          <p className="font-outfit text-4xl font-bold text-white">
            {formatCurrency(loanAmount > 0 ? loanAmount : 0)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepCalculator;
